import { getCookie } from 'cookies-next';

/**
 * Read AhaFood auth token from `token` cookie.
 * Returns empty string nếu không có (matches existing callsite expectations).
 */
export function getAuthToken(): string {
  const token = getCookie('token');
  if (typeof token === 'string' && token) return token;
  return '';
}

/**
 * Same as getAuthToken but returns null instead of empty string.
 * Use for `enabled: !!token` patterns.
 */
export function getAuthTokenOrNull(): string | null {
  const t = getAuthToken();
  return t || null;
}
